<template>
  <!--  关于wire China-->
  <div
    style="
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
	  padding-top: 60px;
    "
  >
    <Breadcrumb
      :value="[$t('h.tabName1'), $t('h.tabName2'), $t('h.tabName2Item1')]"
    />
    <div style="width: 1200px; height: auto">
      <div
        style="
          margin: 24px 0 24px 0;
          overflow: hidden;
          width: 100%;
          height: 330px;
        "
      >
        <img
          class="customImage"
          src="@/assets/img/zhanhuigaikuang.jpg"
          style="width: 100%; height: 100%"
        />
      </div>
      <div style="width: 100%; padding: 0 24px">
        <a-button-group>
          <a-button
            @click="tabChange(index)"
            v-for="(item, index) in tabData"
            :key="index"
            :style="
              item.select
                ? 'color: #FFFFFF;background: #d7000F;border: none;'
                : 'color: #666666;background: transparent;border: 1px solid #DDDDDD;'
            "
            style="
              width: 288px;
              height: 48px;
              font-family: SourceHanSansCN-Medium;
              font-size: 18px;
            "
          >
            {{ item.label }}
          </a-button>
        </a-button-group>
        <!--基本信息-->
        <div v-if="tabIndex === 0" style="margin-top: 24px">
          <div style="display: flex; width: 100%; ">
            <div
              style="
                width: 637px;
                height: 370px;
                border-radius: 10px;
                margin-right: 30px;
                overflow: hidden;
              "
            >
              <img
                class="customImage"
                :src="$language == 'ZH' ? infoZhIcon : infoEnIcon"
              />
            </div>
            <div
              style="
                width: 491px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="customLabel baseContent" style="padding-top: 12px;text-align: justify;">
                <span style="font-size: 22px;color: #d7000F;">{{ $t('h.home.box2.title') }}</span>
                <span style="font-size: 18px;color: #444444; font-family: Arial, sans-serif;">{{ $t('h.home.box2.content') }}</span>
              </div>
              <div style="display: flex; flex-direction: column; gap: 12px; padding: 16px; background-color: #f9f9f9; border-radius: 8px;">
                <div
                  style="
                    font-family: Arial, sans-serif;
                    font-size: 18px;
                    color: #666666;
                    white-space: pre-line;
                    line-height: 1.5;
                  "
                >
                  {{ $t("h.about.box1.date") }}
                </div>
                <div
                  style="
                    font-family: Arial, sans-serif;
                    font-size: 18px;
                    color: #666666;
                    padding-top: 8px;
                    border-top: 1px solid #e0e0e0;
                  "
                >
                  {{ $t("h.about.box1.addressLabel")
                  }}<a @click="openUrl" style="font-family: Arial, sans-serif;">{{
                    $t("h.about.box1.addressValue")
                  }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="baseTitle" style="padding-top: 40px; font-family: Arial, sans-serif;">
            {{ $t("h.about.box1.title") }}
          </div>
          <div style="margin-top: 24px; padding: 24px; background-color: #f9f9f9; border-radius: 8px;">
            <div
              v-for="(item, index) in listData"
              :key="index"
              style="margin-bottom: 32px; padding-bottom: 24px; border-bottom: 1px solid #e0e0e0"
            >
              <div class="flex align-center" style="padding-bottom: 16px;">
                <div class="baseTitle" style="font-family: Arial, sans-serif; font-size: 20px;">
                  {{ item.title }}
                </div>
                <div @click="urlTo(item.url)" class="flex align-center" style="margin-left: 24px;">
                  <div
                    style="
                      width: 20px;
                      height: 20px;
                      background: red;
                      border-radius: 20px;
                      cursor: pointer;
                      margin-right: 8px;"
                    class="flex align-center justify-center">
                    <img
                      src="@/assets/img/guanwangurl.png"
                      style="width: 16px; height: 12px"
                    />
                  </div>
                  <div
                    style="
                      font-weight: 500;
                      font-size: 16px;
                      color: #d7000F;
                      cursor: pointer;
                      font-family: Arial, sans-serif;
                    "
                  >
                    {{ $t("h.about.box1.web") }}
                  </div>
                </div>
              </div>
              <div style="width: 100%;text-align: justify; display: flex; gap: 24px;">
                <div style="width: 96px; flex-shrink: 0;">
                  <div style="width: 96px; height: 96px; overflow: hidden; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                    <img
                      class="customImage"
                      style="width: 100%; height: 100%; object-fit: contain; background-color: white;"
                      :src="item.image"
                    />
                  </div>
                </div>
                <div class="baseContent customLabel" style="text-indent: 0; flex: 1; font-family: Arial, sans-serif; line-height: 1.6; font-size: 16px;">
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--<img
            v-if="$language === 'ZH'"
            src="@/assets/img/media.jpg"
            style="width: 100%; height: 100%; margin-top: 20px;margin-bottom: 20px;"
          />
          <div v-else style="height: 100px"></div>-->
		  <a @click="openUrlmedia"><img :src="$language == 'ZH' ? mediaZhIcon : mediaEnIcon" style="width: 100%; height: 100%; margin-top: 20px;margin-bottom: 20px;" /></a>
        </div>
        <!--展品范围&观众来源-->
        <div v-else-if="tabIndex === 1" style="padding-bottom: 100px">
          <div class="baseTitle" style="padding: 30px 0">
            {{ $t("h.about.box2.title1") }}
          </div>
          <div class="list-container-radius">
            <div
              class="list-item-radius"
              v-for="(item, index) in listData2"
              :key="index"
            >
              <div style="display: flex; flex-direction: column">
                <div
                  style="
                    width: 100%;
                    height: 203px;
                    border-radius: 4px;
                    overflow: hidden;
                  "
                >
                  <img
                    :src="item.imageUrl"
                    class="customImage"
                    object-fit="cover"
                  />
                </div>
                <div
                  class="customLabel"
                  style="
                    font-family: SourceHanSansCN-Medium;
                    font-size: 17px;
                    color: #444444;
                    text-align: center;
                    line-height: 24px;
                    padding: 24px 0;
                  "
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="baseTitle" style="padding: 60px 0">
            {{ $t("h.about.box2.title2") }}
          </div>
          <div class="list-container-vistor">
            <div
              class="list-item-vistor customLabel"
              v-for="(item, index) in listData3"
              :key="index"
            >
              <a-button class="custom-btn" type="link">
                {{ item }}
              </a-button>
            </div>
          </div>
        </div>
        <!--上届概览-->
        <div v-else-if="tabIndex === 2" style="padding-bottom: 100px">
          <div style="padding-top: 60px" v-html="html" class="rich-content"></div>
          <!--          <div class="baseTitle"-->
          <!--               style="padding: 60px 0;">-->
          <!--            {{ $t('h.about.box3.title1') }}-->
          <!--          </div>-->
          <!--          <div style="display: flex;">-->
          <!--            <div style="width: 637px;min-height: 390px;border-radius: 4px;margin-right: 24px;overflow: hidden;">-->
          <!--              <img class="customImage"-->
          <!--                   src="@/assets/img/shangjiegailan1.jpg"/>-->
          <!--            </div>-->
          <!--            <div class="customLabel baseContent"-->
          <!--                 v-if="$language === 'ZH'"-->
          <!--                 style="width: 491px;padding-top: 6px;white-space: pre-line;text-indent: 0;">作为亚洲一流的线缆线材行业盛会，wire China-->
          <!--              2023展会全方位呈现了行业新技术、新产品、新理念，与企业共同把握数字化、智能化、绿色化发展机遇，助力行业开启“加速跑”新征程!-->
          <!--              来自<span class="emphasize"> 96 </span>个国家和地区的<span class="emphasize"> 40,629 </span>名专业观众，较2018年增长了<span-->
          <!--                  class="emphasize"> 30.83%</span>-->
          <!--              来自<span class="emphasize"> 19 </span>个国家和地区的<span class="emphasize"> 900 </span>多家线缆及线材行业品牌展商-->
          <!--              <span class="emphasize">57,500 </span>平方米的专业展览平台-->
          <!--              <span class="emphasize">2 </span>大行业会议、<span class="emphasize">4 </span>场主题论坛、<span-->
          <!--                  class="emphasize">40+ </span>主题交流提领未来破局之道-->
          <!--              <span class="emphasize">5 </span>大主题路线 精准高效沉浸逛展-->
          <!--            </div>-->
          <!--            <div class="customLabel baseContent"-->
          <!--                 v-else-->
          <!--                 style="width: 491px;padding-top: 6px;white-space: pre-line;text-indent: 0;">As Asia's first-class cable-->
          <!--              and wire industry event, wire China 2023 presents new technologies, new products and new concepts in the-->
          <!--              industry in all aspects, and jointly seizes the development opportunities of digitalization, intelligence-->
          <!--              and greening with enterprises, helping the industry to embark on a new journey of "accelerating"!-->
          <!--              <span class="emphasize"> 40,629 </span>professional visitors from<span class="emphasize"> 96 </span>countries-->
          <!--              and regions, an increase of<span class="emphasize"> 30.83%</span>over 2018-->
          <!--              More than<span class="emphasize"> 900 </span>cable and wire industry brand exhibitors from<span-->
          <!--                  class="emphasize"> 19 </span>countries and regions-->
          <!--              <span class="emphasize">57,500 </span>square meters of professional exhibition platform-->
          <!--              <span class="emphasize">2 </span>major industry conferences, <span class="emphasize">4 </span>theme-->
          <!--              forums, <span class="emphasize">40+ </span>theme exchanges to provide future breakthroughs-->
          <!--              <span class="emphasize">5 </span>major theme routes for precise and efficient immersive exhibition-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="baseTitle"-->
          <!--               style="padding-top: 78px;padding-bottom: 60px;">-->
          <!--            {{ $t('h.about.box3.title2') }}-->
          <!--          </div>-->
          <!--          <div style="display: flex;">-->
          <!--            <div-->
          <!--                style="width: 692px;margin-right: 24px;display:flex;flex-direction: column;justify-content: space-between;">-->
          <!--              <div class="baseContent"-->
          <!--                   style="padding-top: 6px;">-->
          <!--                <div class="customLabel" style="text-indent: 2em;">-->
          <!--                  {{ $t('h.about.box3.content2') }}-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div style="width: 100%;height: auto;border-radius: 4px;margin-top: 18px;overflow: hidden;">-->
          <!--                <img class="customImage"-->
          <!--                     src="@/assets/img/shangjiegailan2.jpg"/>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--            <div style="width: 434px;min-height: 549px;border-radius: 4px;overflow: hidden;">-->
          <!--              <img class="customImage" src="@/assets/img/shangjiegailan3.jpg"/>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="baseTitle"-->
          <!--               style="padding: 60px 0;">-->
          <!--            {{ $t('h.about.box3.title3') }}-->
          <!--          </div>-->
          <!--          <div style="display: flex;">-->
          <!--            <div class="customLabel baseContent"-->
          <!--                 style="width: 491px;padding-top: 6px;margin-right: 24px;">-->
          <!--              {{ $t('h.about.box3.content3') }}-->
          <!--            </div>-->
          <!--            <div style="width: 637px;min-height: 390px;border-radius: 4px;overflow: hidden;">-->
          <!--              <img class="customImage"-->
          <!--                   src="@/assets/img/shangjiegailan4.jpg"/>-->
          <!--            </div>-->

          <!--          </div>-->
          <!--          <div class="baseTitle"-->
          <!--               style="padding: 60px 0;">-->
          <!--            {{ $t('h.about.box3.title4') }}-->
          <!--          </div>-->
          <div style="width: 100%">
<!--                       <div class="customLabel baseContent">
                         {{ $t('h.about.box3.content4') }}
                       </div> -->
            <!--            <div style="display: flex;margin-top: 12px;height: 280px;">-->
            <!--              <div style="flex: 1;overflow: hidden;border-radius: 4px;">-->
            <!--                <img class="customImage" style="object-fit: contain;" src="@/assets/img/shangjiegailan5.jpg"/>-->
            <!--              </div>-->
            <!--              <div style="width: 24px;"></div>-->
            <!--              <div style="flex: 1;overflow: hidden;border-radius: 4px;">-->
            <!--                <img class="customImage" style="object-fit: contain;" src="@/assets/img/shangjiegailan6.jpg"/>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--            <div class="baseTitle"-->
            <!--                 style="padding: 60px 0;">-->
            <!--              {{ $t('h.about.box3.title5') }}-->
            <!--            </div>-->
            <!--            <div style="display: flex;">-->
            <!--              <div style="width: 637px;min-height: 390px;border-radius: 4px;margin-right: 24px;overflow: hidden;">-->
            <!--                <img class="customImage"-->
            <!--                     src="@/assets/img/shangjiegailan7.jpg" style="object-position: left"/>-->
            <!--              </div>-->
            <!--              <div class="customLabel baseContent"-->
            <!--                   style="width: 491px;padding-top: 6px;white-space: pre-line;text-indent: 0;">-->
            <!--                {{ $t('h.about.box3.content5') }}-->
            <!--              </div>-->
            <!--            </div>-->
            <div
              style="
                width: 100%;
                height: 90px;
                background: #f5f5f5;
                border-radius: 1px;
                padding-right: 40px;
                margin-top: 24px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;
                font-size: 18px;
              "
            >
              <img
                src="@/assets/img/hongseyuanjiantou.png"
                style="
                  width: 18px;
                  height: 18px;
                  margin-right: 10px;
                  cursor: pointer;
                "
              />
              <a
                @click="
                  urlTo(
                    'https://book.yunzhan365.com/eqdbv/szdn/mobile/index.html'
                  )
                "
                >{{ $t("h.about.box3.reviewOfLastSession") }}</a
              >
            </div>
          </div>
        </div>
        <!--联系我们-->
        <div v-else style="padding-bottom: 100px">
          <!-- 中文页面：使用静态内容显示联系信息 -->
          <div v-if="$language === 'ZH'">
            <div class="baseTitle" style="padding: 60px 0">
              参展联络
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">中国大陆地区品牌参展</h3>
                <p style="color: #444444; margin-bottom: 12px">上海电缆研究所有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">丁璇 女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: 021-6548 3517</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: exhibition@secri.com</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">合资/海外品牌（含港澳台）</h3>
                <p style="color: #444444; margin-bottom: 12px">杜塞尔多夫展览（上海）有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">顾先生 / 曹女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: 021 - 6169 8373 / 8369</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: alex.gu@mds.cn / mary.cao@mds.cn</p>
              </div>
            </div>
            
            <div class="baseTitle" style="padding: 60px 0">
              参观联络/商贸配对
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">中国大陆地区</h3>
                <p style="color: #444444; margin-bottom: 12px">上海电缆研究所有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">王诺涵 女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: 021-5116 6070</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: wangnuohan@secri.com</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">港澳台及海外地区</h3>
                <p style="color: #444444; margin-bottom: 12px">杜塞尔多夫展览（上海）有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">黄娓 女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: +86 21 6169 8317</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: vivian.huang@mds.cn</p>
              </div>
            </div>
            
            <div class="baseTitle" style="padding: 60px 0">
              媒体合作
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">中国大陆地区</h3>
                <p style="color: #444444; margin-bottom: 12px">上海电缆研究所有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">卢羽佳 女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: 021-5117 9615</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: luyujia@secri.com</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">港澳台及海外地区</h3>
                <p style="color: #444444; margin-bottom: 12px">杜塞尔多夫展览（上海）有限公司</p>
                <p style="color: #444444; margin-bottom: 12px">黄娓 女士</p>
                <p style="color: #444444; margin-bottom: 12px">电话: +86 21 6169 8317</p>
                <p style="color: #444444; margin-bottom: 12px">电邮: vivian.huang@mds.cn</p>
              </div>
            </div>
          </div>
          <!-- 英文页面：显示静态内容 -->
          <div v-else>
            <div class="baseTitle" style="padding: 60px 0">
              Exhibitor Inquiry
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Brand in China and other Asian Countries</h3>
                <p style="color: #444444; margin-bottom: 12px">Messe Düsseldorf (Shanghai) Co., Ltd.</p>
                <p style="color: #444444; margin-bottom: 12px">Contact: Mr. Alex Gu / Ms. Mary Cao</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: 86-21-6169 8373 / -8369</p>
                <p style="color: #444444; margin-bottom: 12px">Email: wire@mds.cn</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Brand in Europe and North-/South America</h3>
                <p style="color: #444444; margin-bottom: 12px">Messe Düsseldorf GmbH</p>
                <p style="color: #444444; margin-bottom: 12px">Contact: Ms. Sarah Liehsem</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: +49 (0) 211 4560 7760</p>
                <p style="color: #444444; margin-bottom: 12px">Email: LiehsemS@messe-duesseldorf.de</p>
              </div>
            </div>
            
            <div class="baseTitle" style="padding: 60px 0">
              Visitor Inquiry
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Mainland China</h3>
                <p style="color: #444444; margin-bottom: 12px">Shanghai Electric Cable Research Institute Co., Ltd.</p>
                <p style="color: #444444; margin-bottom: 12px">Ms. Wang Nuohan</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: 021-5116 6070</p>
                <p style="color: #444444; margin-bottom: 12px">Email: wangnuohan@secri.com</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Hong Kong, Macau, Taiwan and Overseas</h3>
                <p style="color: #444444; margin-bottom: 12px">Messe Düsseldorf (Shanghai) Co., Ltd.</p>
                <p style="color: #444444; margin-bottom: 12px">Ms. Charlotte Shi / Ms. Vivian Huang</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: +86 21 6169 8320 / 8317</p>
                <p style="color: #444444; margin-bottom: 12px">Email: wiretube_visitor@mds.cn</p>
              </div>
            </div>
            
            <div class="baseTitle" style="padding: 60px 0">
              Media Cooperation
            </div>
            <div style="display: flex; margin-bottom: 40px">
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px; margin-right: 24px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Mainland China</h3>
                <p style="color: #444444; margin-bottom: 12px">Shanghai Electric Cable Research Institute Co., Ltd.</p>
                <p style="color: #444444; margin-bottom: 12px">Ms. Lu Yujia</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: 021-137 6102 8079</p>
                <p style="color: #444444; margin-bottom: 12px">Email: luyujia@secri.com</p>
              </div>
              <div style="flex: 1; background: #F5F5F5; padding: 40px; border-radius: 4px">
                <h3 style="color: #212121; margin-bottom: 24px; font-size: 18px; font-weight: 600">Hong Kong, Macau, Taiwan and Overseas</h3>
                <p style="color: #444444; margin-bottom: 12px">Messe Düsseldorf (Shanghai) Co., Ltd.</p>
                <p style="color: #444444; margin-bottom: 12px">Ms. Charlotte Shi / Ms. Vivian Huang</p>
                <p style="color: #444444; margin-bottom: 12px">Tel: +86 21 6169 8320 / 8317</p>
                <p style="color: #444444; margin-bottom: 12px">Email: wiretube_visitor@mds.cn</p>
              </div>
            </div>
          </div>
          <!--          <div v-for="(item,index) in listData4" :key="index">-->
          <!--            <div class="baseTitle"-->
          <!--                 style="padding: 60px 0;">-->
          <!--              {{ item.title }}-->
          <!--            </div>-->
          <!--            <div style="display: flex;height: 300px;">-->
          <!--              <div class="customCard"-->
          <!--                   style="flex: 1;height: 100%;background: #F5F5F5;display: flex;flex-direction: column;justify-content: space-between;">-->
          <!--                <div-->
          <!--                    style="font-family: SourceHanSansOLD-Bold;font-size: 24px;color: #212121;padding: 40px 40px 0 40px;">-->
          <!--                  {{ item.value1 }}-->
          <!--                </div>-->
          <!--                <div style="display: flex;justify-content: space-between;align-items: flex-end;">-->
          <!--                  <div-->
          <!--                      style="display: flex;flex-direction: column;font-family: SourceHanSansCN-Medium;font-size: 16px;color: #444444;line-height: 32px;padding: 0 0 40px 40px;">-->
          <!--                    <div>{{ item.value2 }}</div>-->
          <!--                    <div>{{ item.value3 }}</div>-->
          <!--                    <div>{{ item.value4 }}</div>-->
          <!--                    <div>{{ item.value5 }}</div>-->
          <!--                    <div>{{ item.value11 }}</div>-->
          <!--                  </div>-->
          <!--                  <img v-if="index === 0" style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       src="@/assets/img/about/ExhibitionContact/mainland.png"/>-->
          <!--                  <img v-else-if="index === 1"-->
          <!--                       style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       src="@/assets/img/about/BusinessMatching/mainland.png"/>-->
          <!--                  <img v-else-if="index === 2"-->
          <!--                       style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       object-fit="cover"-->
          <!--                       src="@/assets/img/about/MediaContact/mainland.png"/>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div style="width: 24px;"></div>-->
          <!--              <div class="customCard"-->
          <!--                   style="flex: 1;height: 100%;background: #F5F5F5;display: flex;flex-direction: column;justify-content: space-between;">-->
          <!--                <div-->
          <!--                    style="font-family: SourceHanSansOLD-Bold;font-size: 24px;color: #212121;padding: 40px 40px 0 40px;">-->
          <!--                  {{ item.value6 }}-->
          <!--                </div>-->
          <!--                <div style="display: flex;justify-content: space-between;align-items: flex-end;">-->
          <!--                  <div-->
          <!--                      style="display: flex;flex-direction: column;font-family: SourceHanSansCN-Medium;font-size: 16px;color: #444444;line-height: 32px;padding: 0 0 40px 40px;">-->
          <!--                    <div>{{ item.value7 }}</div>-->
          <!--                    <div>{{ item.value8 }}</div>-->
          <!--                    <div>{{ item.value9 }}</div>-->
          <!--                    <div>{{ item.value10 }}</div>-->
          <!--                    <div>{{ item.value12 }}</div>-->
          <!--                  </div>-->
          <!--                  <img v-if="index === 0" style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       src="@/assets/img/about/ExhibitionContact/noMainland.png"/>-->
          <!--                  <img v-else-if="index === 1"-->
          <!--                       style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       src="@/assets/img/about/BusinessMatching/noMainland.png"/>-->
          <!--                  <img v-else-if="index === 2"-->
          <!--                       style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
          <!--                       src="@/assets/img/about/BusinessMatching/noMainland.png"/>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div
      v-if="tabIndex === 0"
      style="width: 100%; height: auto; position: relative"
    ></div>
  </div>
</template>

<script>
import { codeConfig } from "../../../assets/api";
import listImage1 from "@/assets/img/about/cekongjishu.jpg";
import listImage2 from "@/assets/img/about/jiancegongcheng.jpg";
import listImage3 from "@/assets/img/about/xiancaizhizaojijingjiagongjixie.jpg";
import listImage4 from "@/assets/img/about/fuzhujiagong.jpg";
import listImage5 from "@/assets/img/about/yuanfucailiao.jpg";
import listImage6 from "@/assets/img/about/chengpinxiancaijidianxiandianlan.jpg";
import listImage7 from "@/assets/img/about/tanhuangzhizaoshebeijijishu.jpg";
import listImage8 from "@/assets/img/about/jingujian.jpg";
import listImage9 from "@/assets/img/about/qitaxiangguanlingyu.jpg";

import footer5 from "@/assets/img/footer/icon5.png";
import footer6 from "@/assets/img/footer/icon6.png";

import infoZhIcon from "@/assets/img/about/info-zh.jpg";
import infoEnIcon from "@/assets/img/about/info-en.jpg";
import mediaZhIcon from "@/assets/img/media-zh.jpg";
import mediaEnIcon from "@/assets/img/media-en.jpg";

export default {
  name: "Overview",
  components: {
  },
  data() {
    return {
      infoZhIcon,
      infoEnIcon,
      mediaZhIcon,
      mediaEnIcon,
      tabIndex: 0,
      tabData: [
        {
          label: this.$t("h.about.btn1"),
          select: true,
        },
        {
          label: this.$t("h.about.btn2"),
          select: false,
        },
        {
          label: this.$t("h.about.btn3"),
          select: false,
        },
        {
          label: this.$t("h.about.btn4"),
          select: false,
        },
      ],
      listData: [
        {
          title: this.$t("h.about.box1.listTitle1"),
          image: footer5,
          content: this.$t("h.about.box1.listContent1"),
          url: "https://www.secri.com",
        },
        {
          title: this.$t("h.about.box1.listTitle2"),
          image: footer6,
          content: this.$t("h.about.box1.listContent2"),
          url: "https://www.mds.cn",
        },
      ],
      listData2: [
        {
          title: this.$t("h.about.box2.listLabel1"),
          imageUrl: listImage3,
        },

        {
          title: this.$t("h.about.box2.listLabel2"),
          imageUrl: listImage4,
        },
        {
          title: this.$t("h.about.box2.listLabel3"),
          imageUrl: listImage5,
        },
        {
          title: this.$t("h.about.box2.listLabel4"),
          imageUrl: listImage6,
        },
        {
          title: this.$t("h.about.box2.listLabelNew1"),
          imageUrl: listImage1,
        },
        {
          title: this.$t("h.about.box2.listLabelNew2"),
          imageUrl: listImage2,
        },

        {
          title: this.$t("h.about.box2.listLabel5"),
          imageUrl: listImage7,
        },
        {
          title: this.$t("h.about.box2.listLabel6"),
          imageUrl: listImage8,
        },
        {
          title: this.$t("h.about.box2.listLabelNew3"),
          imageUrl: listImage9,
        },
      ],
      listData3: [
        this.$t("h.about.box2.btn1"),
        this.$t("h.about.box2.btn2"),
        this.$t("h.about.box2.btn3"),
        this.$t("h.about.box2.btn4"),
        this.$t("h.about.box2.btn5"),
        this.$t("h.about.box2.btn6"),
        this.$t("h.about.box2.btn7"),
        this.$t("h.about.box2.btn8"),
        this.$t("h.about.box2.btn9"),
        this.$t("h.about.box2.btn10"),
        this.$t("h.about.box2.btn11"),
        this.$t("h.about.box2.btn12"),
        this.$t("h.about.box2.btn13"),
        this.$t("h.about.box2.btn14"),
        this.$t("h.about.box2.btn15"),
      ],
      // listData4: [
      //   {
      //     title: this.$t('h.about.box4.title1'),
      //     value1: this.$t('h.callingCard.title1'),
      //     value2: this.$t('h.callingCard.company1'),
      //     value3: this.$t('h.callingCard.name1'),
      //     value4: this.$t('h.callingCard.label1') + '021 - 6548 3517',
      //     value5: this.$t('h.callingCard.label2') + 'exhibition@secri.com',
      //     value6: this.$t('h.callingCard.title2'),
      //     value7: this.$t('h.callingCard.company2'),
      //     value8: this.$t('h.callingCard.name2'),
      //     value9: this.$t('h.callingCard.label1') + '+86 21 6169 8369',
      //     value10: this.$t('h.callingCard.label2') + 'wire@mds.cn',
      //     value11: this.$t('h.callingCard.label3') + '13817317046',
      //     value12: this.$t('h.callingCard.label3') + '13801682135',
      //   },
      //   {
      //     title: this.$t('h.about.box4.title2'),
      //     value1: this.$t('h.callingCard.title1'),
      //     value2: this.$t('h.callingCard.company1'),
      //     value3: this.$t('h.callingCard.name3'),
      //     value4: this.$t('h.callingCard.label1') + '021 - 5116 6070',
      //     value5: this.$t('h.callingCard.label2') + 'may@secri.com',
      //     value6: this.$t('h.callingCard.title2'),
      //     value7: this.$t('h.callingCard.company2'),
      //     value8: this.$t('h.callingCard.name4'),
      //     value9: this.$t('h.callingCard.label1') + '+86 21 6169 8320 / 8317',
      //     value10: this.$t('h.callingCard.label2') + 'wiretube_visitor@mds.cn',
      //     value11: this.$t('h.callingCard.label3') + '13681693912',
      //     value12: this.$t('h.callingCard.label3') + '15821213269',
      //   },
      //   {
      //     title: this.$t('h.about.box4.title3'),
      //     value1: this.$t('h.callingCard.title1'),
      //     value2: this.$t('h.callingCard.company1'),
      //     value3: this.$t('h.callingCard.name5'),
      //     value4: this.$t('h.callingCard.label1') + '021-5117 9615',
      //     value5: this.$t('h.callingCard.label2') + 'luyujia@secri.com',
      //     value6: this.$t('h.callingCard.title2'),
      //     value7: this.$t('h.callingCard.company2'),
      //     value8: this.$t('h.callingCard.name4'),
      //     value9: this.$t('h.callingCard.label1') + '+86 21 6169 8320 / 8317',
      //     value10: this.$t('h.callingCard.label2') + 'wiretube_visitor@mds.cn',
      //     value11: this.$t('h.callingCard.label3') + '13761028079',
      //     value12: this.$t('h.callingCard.label3') + '15821213269',
      //   }
      // ],
      html: "",
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      //获取上届概览内容信息
      let code = this.$language === "ZH" ? "LAST_VIEW" : "LAST_VIEW_EN";
      this.$axios.get(codeConfig + code, {}).then((res) => {
        if (res && res.data.success) {
          this.html = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    openUrl() {
      this.$router.push("/transport");
    },
    openUrlmedia() {
      this.$router.push("/media");
    },
    urlTo(url) {
      window.open(url, "_blank");
    },
    tabChange(index) {
      this.tabData.forEach((item, i) => {
        if (index == i) {
          item.select = true;
        } else {
          item.select = false;
        }
      });
      this.tabIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.emphasize {
  color: #d7000F;
  font-weight: bold;
}

.list-container-radius {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 或者使用 space-between 以在项目之间添加间距 */
}

.list-item-radius {
  flex: 0 0 32%; /* 这将确保每个项目占据容器宽度的 1/3 */
  box-sizing: border-box; /* 确保 padding 和 border 不会增加元素的宽度 */
  margin-bottom: 24px; /* 可选：为每行项目添加底部间距 */
}

.list-container-vistor {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 或者使用 space-between 以在项目之间添加间距 */
}

.list-item-vistor {
  flex: 0 0 31%; /* 这将确保每个项目占据容器宽度的 1/3 */
  box-sizing: border-box; /* 确保 padding 和 border 不会增加元素的宽度 */
  margin-bottom: 24px; /* 可选：为每行项目添加底部间距 */
}

a {
  color: #3da5ff;
  text-decoration: none;
  transition: color 0.3s ease; /* 添加颜色过渡效果 */
}

a:hover {
  color: #d7000F;
  text-decoration: underline;
}

a:visited {
  color: #3da5ff;
}

a:active {
  color: yellow;
}

.custom-btn {
  width: 100%;
  height: 48px;
  font-family: SourceHanSansCN-Medium;
  font-size: 17px;
  color: #444444;
  background: transparent;
  border: 1px solid #dddddd;
}

.custom-btn:hover {
  transform: scale(1.05);
  opacity: 0.7;
  background: #d7000F;
  color: white;
}

/* 富文本内容样式 - 支持后台设置的图片居中 */
::v-deep .rich-content img {
  max-width: 100%;
  height: auto;
}

::v-deep .rich-content p[style*="text-align: center"],
::v-deep .rich-content p[style*="text-align:center"],
::v-deep .rich-content div[style*="text-align: center"],
::v-deep .rich-content div[style*="text-align:center"] {
  text-align: center !important;
}

::v-deep .rich-content img[style*="display: block"],
::v-deep .rich-content img[style*="display:block"] {
  display: block !important;
}

::v-deep .rich-content img[style*="margin: 0 auto"],
::v-deep .rich-content img[style*="margin:0 auto"],
::v-deep .rich-content img[style*="margin: 0px auto"] {
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img[style*="text-align: center"],
::v-deep .rich-content img[style*="text-align:center"] {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img[align="middle"],
::v-deep .rich-content img[align="center"] {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content img.align-center,
::v-deep .rich-content img.image-center,
::v-deep .rich-content img.center {
  display: block !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

::v-deep .rich-content p[align="center"],
::v-deep .rich-content div[align="center"] {
  text-align: center !important;
}
</style>
